import styled from "styled-components";
export const Color = styled.div `
  background-color: ${({ $color }) => $color};
  border-radius: 20px;
  height: 100%;
  width: 100%;
`;
